import { render, staticRenderFns } from "./FiltersAlert.vue?vue&type=template&id=352d7608&scoped=true"
import script from "./FiltersAlert.vue?vue&type=script&lang=ts"
export * from "./FiltersAlert.vue?vue&type=script&lang=ts"
import style0 from "./FiltersAlert.vue?vue&type=style&index=0&id=352d7608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d7608",
  null
  
)

export default component.exports